var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/social Copy 10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sign-up",
    transform: "translate(-35.000000, -570.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(25.000000, 492.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/social-Copy-12",
    transform: "translate(10.000000, 78.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-facebook"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23,24 C23.552285,24 24,23.552285 24,23 L24,1 C24,0.447715 23.552285,0 23,0 L1,0 C0.447715,0 0,0.447715 0,1 L0,23 C0,23.552285 0.447715,24 1,24 L23,24 Z",
    id: "White_4_",
    fill: "#39579A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.759585,24 L12.759585,14.5 L9.5,14.5 L9.5,11 L12.759585,11 L12.759585,8.41269 C12.759585,5.312805 14.65289,3.62486 17.4182,3.62486 C18.74281,3.62486 19.881245,3.72348 20.21302,3.76756 L20.21302,7.00712 L18.29513,7.00799 C16.7912,7.00799 16.5,7.722635 16.5,8.771325 L16.5,11 L20,11 L19.5,14.5 L16.5,14.5 L16.5,24 L12.759585,24 Z",
    id: "White_2_",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.25c538369e5ffe8a74a3e81b9b447401.svg";
export { ForwardRef as ReactComponent };